module.exports = __webpack_public_path__ + "media/images/logo-dff65f37340b005d6d732573316ff820.svg";